import React from 'react';
import { 
  Box, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  SelectChangeEvent 
} from '@mui/material';
import { PlacementType } from '../../types/playground';

const PLACEMENTS: { value: PlacementType; label: string }[] = [
  { value: 'before', label: 'Before Response' },
  { value: 'inline', label: 'Inline with Response' },
  { value: 'after', label: 'After Response' },
  { value: 'recommendation', label: 'As Recommendation' }
];

interface PlacementSelectorProps {
  selectedPlacement: PlacementType | null;
  onPlacementChange: (placement: PlacementType) => void;
}

export const PlacementSelector: React.FC<PlacementSelectorProps> = ({ 
  selectedPlacement, 
  onPlacementChange 
}) => {
  const handleChange = (event: SelectChangeEvent<PlacementType>) => {
    onPlacementChange(event.target.value as PlacementType);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <FormControl fullWidth>
        <InputLabel shrink id="placement-select-label" sx={{ color: '#3B82F6' }}>Select Placement</InputLabel>
        <Select
          labelId="placement-select-label"
          id="placement-select"
          value={selectedPlacement || ''}
          label="Select a Placement"
          onChange={handleChange}
          sx={{ 
            backgroundColor: '#1E293B',
            color: '#fff',
            '& .MuiSelect-select': { color: '#fff' },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(148, 163, 184, 0.2)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(148, 163, 184, 0.5)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3B82F6',
            },
            '& .MuiSelect-icon': {
              color: '#CBD5E1',
            },
          }}
        >
          {PLACEMENTS.map((placement) => (
            <MenuItem key={placement.value} value={placement.value}>
              {placement.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}; 